import { observable_component } from 'common/util/ComponentDecorator';
import AbstractReviewForm from '../review-form/review-form';

@observable_component
export default class ShopReviewForm extends AbstractReviewForm {
	static classname = 'shop-review-form';

	constructor($context) {
		super($context);

		this.bindEvents();
	}

	bindEvents() {
		this.$form.on('submit', this.handleSubmitForm);
		this.$context.find('.review-form__button').on('click', () => {
			this.$form.trigger('submit');
		});
	}

	handleSubmitForm = e => {
		this.errors = [];

		$.ajax({
			url: this.form_url,
			type: 'POST',
			data: this.form_data,
			cache: false,
			contentType: false,
			processData: false
		}).then(this.handleAjaxSuccess);

		e.preventDefault();
		return false;
	};

	handleAjaxSuccess = response => {
		if (response.status === 'ok') {
			if (response.data && response.data === 'success') {
				ModalUtil.openContent($(window.shop_review_form_result.success));
			} else {
				ModalUtil.openContent($(window.shop_review_form_result.moderate));
			}
		} else if (response.status === 'fail') {
			let { errors } = response;
			if (!errors) {
				alert('Произошла неизвестная ошибка при попытке отправки формы');
				return;
			}

			if (typeof errors === 'string') {
				alert(errors);
				return;
			}

			errors.forEach(error => {
				this.errors = [...this.errors, error];
			});
		}
	};
}
